import { PrimaryRegularButton } from 'components/ReusableComponents/Button/RegularButtons'
import Datepicker from 'components/ReusableComponents/Datepicker'
import Dialog from 'components/ReusableComponents/Dialog'
import Dropdown from 'components/ReusableComponents/ManageHotel/Dropdown'
import moment from 'moment'
import PropTypes from 'prop-types'
import { useState } from 'react'
import { useHistory } from 'react-router'
import { Link } from 'react-router-dom'
import { useToasts } from 'react-toast-notifications'
import campaignApi from 'services/api/campaign'

import { ReactComponent as CloseIcon } from '../EditCampaign/close.svg'
import styles from './NewCampaign.module.scss'

const NewCampaign = ({ audiences }) => {
  const history = useHistory()

  const [audience, setAudience] = useState('new')
  const [deliveryStartDate, setDeliveryStartDate] = useState()
  const [deliveryFinishDate, setDeliveryFinishDate] = useState()

  const { addToast } = useToasts()

  if (!audiences) {
    return null
  }

  const options = {
    ...audiences.reduce((prev, curr) => ({ ...prev, [curr.id]: curr.name }), {}),
    new: ' Create a new audience'
  }

  function saveAudience() {
    if (audience === 'new') {
      history.push('/custom-campaigns/new-audience')
    } else {
      campaignApi
        .addCustomCampaign({
          audienceId: audience,
          deliveryStartDate,
          deliveryFinishDate
        })
        .then(res => {
          history.push(`/custom-campaigns/${res.item.contentId}/new`)
        })
        .catch(err => {
          addToast(`${err}`, {
            appearance: 'error'
          })
        })
    }
  }

  return (
    <Dialog>
      <div className={styles.resolutionWrapper}>
        <div className={styles.editTextHolder}>
          <div className={styles.title}>
            <div>
              <h2 className={styles.dialogTitle}>New campaign</h2>
              <p className={styles.dialogDesc}>Create new custom campaign</p>
            </div>
            <Link to="/custom-campaigns">
              <CloseIcon />
            </Link>
          </div>
          <div className={styles.content}>
            <Dropdown
              options={options}
              value={audience}
              onChange={e => setAudience(Number(e.target.value))}
              label="Audience"
              className={styles.dropdown}
            />

            <div
              style={{
                opacity: audience !== 'new' ? 1 : 0.5,
                pointerEvents: audience !== 'new' ? 'auto' : 'none'
              }}
            >
              <div className={styles.datepickerHolder}>
                <span className={styles.datepickerLabel}>Start date</span>
                <Datepicker
                  className={styles.datepicker}
                  placeholderText="Select date"
                  selected={deliveryStartDate ? moment(deliveryStartDate).toDate() : null}
                  minDate={moment().toDate()}
                  onChange={date => setDeliveryStartDate(moment(date).format())}
                />
              </div>
              <div className={styles.datepickerHolder}>
                <span className={styles.datepickerLabel}>Must deliver before</span>
                <Datepicker
                  className={styles.datepicker}
                  placeholderText="Select date"
                  selected={
                    deliveryFinishDate ? moment(deliveryFinishDate).toDate() : null
                  }
                  minDate={
                    deliveryStartDate
                      ? moment(deliveryStartDate).add(1, 'day').toDate()
                      : moment().add(1, 'day').toDate()
                  }
                  onChange={date => setDeliveryFinishDate(moment(date).format())}
                />
              </div>
            </div>
          </div>
          <div className={styles.controls}>
            <PrimaryRegularButton
              disabled={audience === 'new' ? false : !deliveryStartDate}
              onClick={saveAudience}
            >
              Next
            </PrimaryRegularButton>
          </div>
        </div>
      </div>
    </Dialog>
  )
}

NewCampaign.propTypes = {
  audiences: PropTypes.array
}

export default NewCampaign
